module.exports = __webpack_public_path__ + "static/digipadala-libre-5fe13229cc87ac9626393ece0791e99c.jpg";